import PropTypes from 'prop-types'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import classes from '../../../index.module.scss'

const ListItem = ({ title, itemId, itemById, deleteItem }) => {
  return (
    <>
      <Element style={{ color: '#3a414b' }} className={classes.locationTitle}>
        {title}
      </Element>
      <div className={classes.itemLocationContainer}>
        {itemId.map((id) => {
          const item = itemById[id]

          if (!item) {
            return ''
          }

          return (
            <Element
              key={item.id}
              style={{
                color: '#191d25',
                backgroundColor: '#F3F3F3',
                border: '1px solid #e5e5e8',
              }}
              className={classes.itemLocation}
            >
              <span>{item.name}</span>
              <Icon
                style={{ color: '#9c9c9c', fontSize: 12 }}
                onClick={() => deleteItem(item.id)}
                className="icon-delete-circle-fill"
              />
            </Element>
          )
        })}
      </div>
    </>
  )
}

ListItem.propTypes = {
  title: PropTypes.node.isRequired,
  itemId: PropTypes.array.isRequired,
  itemById: PropTypes.object.isRequired,
  deleteItem: PropTypes.func.isRequired,
}

export default ListItem
